export enum UserGroupsEnum {
	DASHBOARD = 'Dashboard',
	SUPER_ADMIN = 'SuperAdmin',
	PASSES = 'Passes',
	ADMINISTRATOR = 'Administrator',
	PRODUCTS = 'Products',
}
